jQuery(document).ready(function($) {
	
	$('#navclick').click(function(){
		$(this).toggleClass('toggled');
		$('#navContent').toggleClass('open');
	});

	function setMenuHeight() {
	    if (window.innerWidth > 700) {
	        var menuHeight = $(".top-matter").height();
	        $(".first-content").css("padding-top", menuHeight);
	        document.documentElement.style.setProperty('--menuHeight', `${menuHeight}px`);
	    }
	}

	setMenuHeight();

	$(window).resize(function() {
	    setMenuHeight();
	});

});
